import React, { useEffect, useRef } from 'react';
import { HeroImage, useOidcAuthentication } from '@cp-shared-10/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { useGenericErrorPage } from './useGenericErrorPage';
import { GenericErrorType } from './utils/enums';
import { useLogin } from '../../../auth/useLogin';
import { useHistory } from 'react-router-dom';
import { dashboardPagePath, notAuthorizedPagePath, errorPagePath } from '../../navigation/paths';
import { getUrlSearchParams } from '../../../utils/getUrlSearchParams';

export type ErrorTypeProps = {
    errorType: GenericErrorType;
};

const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);

export const GenericErrorPage: React.FC<ErrorTypeProps> = ({ errorType }) => {
    const { cmsContent: errorPageContents, isLoading, loadingError } = useGenericErrorPage();
    const history = useHistory();
    const login = useLogin();
    const { logout } = useOidcAuthentication();
    const initializedRef = useRef(false);
    const clickHandler = () =>
        logout({
            // eslint-disable-next-line @typescript-eslint/camelcase
            post_logout_redirect_uri: `${window.location.origin}${errorPagePath()}?errorType=${errorType}&reauth=1`,
        });

    let errorPageContent = errorPageContents?.general;

    switch (errorType) {
        case GenericErrorType.ALREADY_LOGIN_ERR:
            history.push(dashboardPagePath());
            break;
        case GenericErrorType.INVALID_SESSION_ERR:
            history.push(notAuthorizedPagePath());
            break;
        case GenericErrorType.CONSENT_DENIED_ERR:
            errorPageContent = errorPageContents?.consentDenied;
            break;
        case GenericErrorType.DIFFERENT_USER_ERR:
            errorPageContent = errorPageContents?.differentUser;
            break;
    }

    useEffect(() => {
        if (initializedRef.current) {
            return;
        }
        initializedRef.current = true;

        if (getUrlSearchParams().get('reauth') === '1') {
            login();
        }
    }, [errorType, history, login]);

    return (
        <HeroImageWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            title={errorPageContent?.title || ''}
            subTitle={errorPageContent?.subTitle}
            buttonText={errorPageContent?.buttonText}
            clickHandler={clickHandler}
        />
    );
};
